export default __webpack_public_path__ + "static/media/lt-logo-green.1a6d544c.svg";